import { NonPrimitiveType } from "../../../types/NonPrimitiveType.ts";

/**
 * Base "class" of all java interfaces
 */
export class InterfaceClass {

}